/**
 * @module app.um
 */

import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IDocumentsConfig } from 'app/core/models/essette-interfaces';
import { Subscription, EventAggregator } from 'aurelia-event-aggregator';
import { AuthPageContext } from 'app/um/lib/auth-page-context';
import { AuthChangeEvent } from 'app/um/lib/events';


@autoinject()
export class AuthDocumentsPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @observable
    protected authId: string | null = null;

    protected readonly: boolean = false;

    protected documentsConfig: IDocumentsConfig = {
        serviceRootUrl: 'um/auths',
        targetType: 'UM.Auth',
        addTargetProperty: (document: any /*UM.AuthDocument*/) => { document.auth = { id: this.authId } }
    };

    private subscriptions: Array<Subscription> = [];


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly context: AuthPageContext,
        private readonly events: EventAggregator,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async canActivate(params: { authId: string }): Promise<boolean> {
        if(!params.authId) { throw new Error('Missing or invalid authId parameter'); }

        return true;
    }

    protected async activate(params: { authId: string }): Promise<void> {
        if(this.authId !== params.authId) { this.authId = params.authId; }

        this.checkPermissions();

        this.subscriptions.push(
            this.events.subscribe(AuthChangeEvent, (e: AuthChangeEvent) => this.handleAuthChangeEvent(e))
        );
    }

    protected deactivate(): void {
        this.subscriptions.forEach(s => s.dispose());
        this.subscriptions = [];
    }


    ////****************** Events ***************************************************////
    protected handleAuthChangeEvent(e: AuthChangeEvent): void {
        if(e.authReloaded) {
            this.checkPermissions();
        };
    }


    ////****************** Functions ************************************************////
    private async checkPermissions(): Promise<void> {
        await this.accountContext.load();
        const canEditAuth = this.accountContext.hasPermission('UM.Auth.Duty.EditAuth');
        const canEditClosedAuth = this.accountContext.hasPermission('UM.Auth.Duty.EditClosedAuth');
        const canUploadToClosedAuth = this.accountContext.hasPermission('UM.AuthDocument.Duty.EditUpdateClosedAuthDocuments');

        this.readonly = this.context?.authIsReadOnly(canEditAuth, canEditClosedAuth) && !canUploadToClosedAuth;
    }


    ////****************** Service Calls ********************************************////

}
